import { render } from "./SpeakerModal.vue?vue&type=template&id=5af7d3ab"
import script from "./SpeakerModal.vue?vue&type=script&lang=js"
export * from "./SpeakerModal.vue?vue&type=script&lang=js"

import "./SpeakerModal.vue?vue&type=style&index=0&id=5af7d3ab&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__